import { api } from '@/core/api/';
const URL = 'api/rp';

export const getRemedyFilters = () => api.get(`${URL}/initfilters`);

export const getRequestInfo = (studentSieId, requestId) =>
  api.get(`${URL}/requestinfo`, {
    params: {
      studentSieId,
      requestId,
    },
  });

export const validateUniqueService = (requestId, requestServiceId) =>
  api.get(`${URL}/requestservice/validunique/${requestId}/${requestServiceId}`);

export const removeRequestService = (requestId, requestServiceId) =>
  api.delete(`${URL}/removerequestservice/`, {
    params: {
      requestId,
      requestServiceId,
    },
  });

export const isLastRequestService = (requestId, requestServiceId) =>
  api.get(`${URL}/isLastRequestService/`, {
    params: {
      requestId,
      requestServiceId,
    },
  });
export const getTherapyServiceCatalog = () =>
  api.get(`${URL}/therapyservicecatalog`);

export const getRPServiceTypes = () => api.get(`${URL}/servicetypes`);

export const getDisciplineTypes = (serviceTypeId) =>
  api.get(`${URL}/disciplinetypes/${serviceTypeId}`);

export const getDisciplineTypesForSaee = (serviceTypeId) =>
  api.get(`${URL}/disciplineTypesForSaee/${serviceTypeId}`);

export const getRpDisciplineTypes = (serviceTypeId, studentSieId = null) =>
  api.get(`${URL}/rpdisciplinetypes/${serviceTypeId}`, {
    params: {
      studentSieId,
    },
  });

export const requestServices = (filters, pageIndex, pageSize) =>
  api.get(`${URL}/requestservices`, {
    params: {
      ...filters,
      pageIndex,
      pageSize,
    },
  });

export const getRequestServicesById = (rpId) =>
  api.get(`${URL}/requestServicesById?rpId=${rpId}`);

export const saveRequest = (params) =>
  api.post(`${URL}/saverequest`, params, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

export const getDeterminationReasons = (serviceStatusId, serviceTypeId) =>
  api.get(`${URL}/determinationreasons`, {
    params: {
      serviceStatusId,
      serviceTypeId,
    },
  });

export const getReasonCategories = (reasonId) =>
  api.get(`${URL}/reasonCategories`, {
    params: {
      reasonId,
    },
  });

export const saveDetermination = (params) =>
  api.post(`${URL}/savedetermination`, params, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

export const getRpStatusHistory = (requestServiceId, pageIndex, pageSize) =>
  api.get(`${URL}/servicestatushistory/${requestServiceId}`, {
    params: {
      pageIndex,
      pageSize,
    },
  });

export const markServicesAsPrinted = (requestServiceIds) =>
  api.put(`${URL}/markAsPrinted`, requestServiceIds);

export const requestProviderAddress = (requestServiceId, providerId) =>
  api.get(`${URL}/requestprovideraddress/${requestServiceId}`, {
    params: {
      providerId,
    },
  });

export const getAppointment = (filters) =>
  api.get(`${URL}/appointment`, {
    params: {
      ...filters,
    },
  });

export const getDeterminationRequestService = (id) =>
  api.get(`${URL}/determinationRequestServiceId?requestServiceId=${id}`);

export const getRpContractHistory = (requestServiceId, pageIndex, pageSize) =>
  api.get(`${URL}/servicecontracthistory/${requestServiceId}`, {
    params: {
      pageIndex,
      pageSize,
    },
  });

export const returnToPreviousStatust = (payload) =>
  api.post(`${URL}/returnToPreviousStatus`, payload);

export const getRpPreviousStatust = (requestServiceId) =>
  api.get(`${URL}/statusToReturn?requestServiceId=${requestServiceId}`);

export const getRpRequestDocuments = (requestId, requestServiceId) =>
  api.get(`${URL}/requestdocuments/${requestId}/${requestServiceId}`);

export const getBlogCommentTypes = () =>
  api.get(`${URL}/requestservice/blog/commenttypes`);

export const addBlogItem = (requestServiceId, payload) =>
  api.post(`${URL}/requestservice/blog/${requestServiceId}`, payload, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

export const getBitacoraItems = (requestServiceId) =>
  api.get(`${URL}/requestservice/blog/${requestServiceId}`);

export const getCheckStudentAdmission = (
  academicYearId,
  studentSieId,
  disciplineTypeId
) =>
  api.get(
    `${URL}/checkstudentadmission/${academicYearId}/${studentSieId}/${disciplineTypeId}`
  );

export const returnToNewStatus = (payload) =>
  api.post(`${URL}/returntonewstatus`, payload);

export const requestServiceReconsideration = (payload) =>
  api.post(`${URL}/requestreconsideration`, payload);

export const getParentsSignatures = (studentSieId, contractId) =>
  api.get(`${URL}/parents/${studentSieId}/${contractId}`);

export const getAdmissionByRequestServiceId = (requestServiceId) =>
  api.get(`${URL}/admission/${requestServiceId}`);
